import ExtractToEmail from './ExtractToEmail';

export default ExtractToEmail;
